import React from 'react';
import { Link } from 'react-router-dom';
import './ForecastingHero.css';

// Reusing a decorative graphic
import graphicImg from '../../assets/images/stats-hero-graphic.png';

const ForecastingHero = () => {
  return (
    <section className="forecasting-hero-section">
      <div className="forecasting-hero-content">
        <h1>Commodity forecasting built for operational efficiency</h1>
        <p>
          Our forecasting model blends historical data, real-time sentiment, and predictive analytics to deliver highly accurate, market-aligned crop price forecasts.
        </p>
        <Link to="/signup">
          <button className="book-consultation-btn">Book a consultation</button>
        </Link>
      </div>
      <div className="forecasting-hero-graphic">
        <img src={graphicImg} alt="Forecasting and Data Graphic" />
      </div>
    </section>
  );
};

export default ForecastingHero;